import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getType } from 'typesafe-actions';
import { closeErrorMessage, setTraceId, uploadFailed, uploadStart, uploadReset } from '../actions/upload';
var initialState = {
  uploading: false,
  error: false
};
var uploadReducer = function uploadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case getType(setTraceId):
      return _objectSpread(_objectSpread({}, state), {}, {
        traceId: action.payload.traceId
      });
    case getType(uploadStart):
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: true
      });
    case getType(uploadFailed):
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false,
        error: true
      });
    case getType(closeErrorMessage):
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false,
        error: false
      });
    case getType(uploadReset):
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false
      });
    default:
      return state;
  }
};
export default uploadReducer;